var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CollectionModel } from "../smart";
import { take } from 'rxjs/operators';
var DataTreeModel = /** @class */ (function (_super) {
    __extends(DataTreeModel, _super);
    function DataTreeModel(idGetter, childsGetter, loader, initialValue) {
        var _this = _super.call(this, idGetter, loader, initialValue) || this;
        _this.getItemChilds = childsGetter;
        return _this;
    }
    DataTreeModel.prototype.getItemById = function (id) {
        var _this = this;
        var foundItem = null;
        this.traverseTreeNodes(this.getValue().items, function (item) {
            if (id === _this.getItemID(item)) {
                foundItem = item;
                return true;
            }
            return;
        });
        return foundItem;
    };
    DataTreeModel.prototype.updatedItemById = function (id, newData) {
        var _this = this;
        this.update(function (values) {
            _this.traverseTreeNodes(values.items, function (item) {
                if (id === _this.getItemID(item)) {
                    Object.assign(item, newData);
                    return true;
                }
                return;
            });
        });
    };
    DataTreeModel.prototype.withAdditionalValues = function (additionalValues) {
        var _a, _b;
        var _c = this.getValue(), checked = _c.checked, expanded = _c.expanded;
        return _super.prototype.withAdditionalValues.call(this, __assign(__assign({}, additionalValues), { checked: (_a = additionalValues.checked) !== null && _a !== void 0 ? _a : checked, expanded: (_b = additionalValues.expanded) !== null && _b !== void 0 ? _b : expanded }));
    };
    DataTreeModel.prototype.fetchNode = function (node) {
        return this.loader(this.getValue(), node).pipe(take(1));
    };
    DataTreeModel.prototype.traverseTreeNodes = function (items, callback) {
        var _a;
        var current;
        var visitors = items.slice().reverse();
        while ((current = visitors.pop())) {
            if (callback(current) === true) {
                return;
            }
            visitors.push.apply(visitors, ((_a = this.getItemChilds(current)) !== null && _a !== void 0 ? _a : []).slice().reverse());
        }
    };
    DataTreeModel.prototype.actualizeSelection = function () {
        var _this = this;
        var _a = this.getValue(), selection = _a.selection, checked = _a.checked, expanded = _a.expanded;
        if (!selection.length && !checked.length && !expanded.length) {
            return;
        }
        var prevSelection = selection.slice();
        var prevChecked = checked.slice();
        var prevExpanded = expanded.slice();
        var resultSelection = [];
        var resultChecked = [];
        var resultExpanded = [];
        this.traverseTreeNodes(this.getValue().items, function (item) {
            var _a;
            var id = _this.getItemID(item);
            var findedSelectedIdx = prevSelection.findIndex(function (selectedId) { return selectedId === id; });
            if (findedSelectedIdx > -1) {
                resultSelection.push.apply(resultSelection, prevSelection.splice(findedSelectedIdx, 1));
            }
            var findedCheckedIdx = prevChecked.findIndex(function (checkedId) { return checkedId === id; });
            if (findedCheckedIdx > -1) {
                resultChecked.push.apply(resultChecked, prevChecked.splice(findedCheckedIdx, 1));
            }
            var findedExpandedIdx = prevExpanded.findIndex(function (expandedId) { return expandedId === id; });
            if (findedExpandedIdx > -1) {
                var findedExpandedId = prevExpanded.splice(findedExpandedIdx, 1);
                if ((_a = _this.getItemChilds(item)) === null || _a === void 0 ? void 0 : _a.length) {
                    resultExpanded.push.apply(resultExpanded, findedExpandedId);
                }
            }
            if (!prevSelection.length && !prevChecked.length && !prevExpanded.length) {
                return true;
            }
            return;
        });
        this.update(function (prevValue) {
            prevValue.selection = resultSelection;
            prevValue.checked = resultChecked;
            prevValue.expanded = resultExpanded;
        });
    };
    return DataTreeModel;
}(CollectionModel));
export { DataTreeModel };
//# sourceMappingURL=DataTreeModel.js.map